import { getSARangeAPI } from '@src/api'

let SARangeArr;

// 获取年龄对应的保额范围
export async function getSARangeByAge(goodsId, planId, age) {
  if(!goodsId || !planId || typeof age === undefined) return;
  

  if(!SARangeArr) {
    SARangeArr = await getSARangeAPI(goodsId, planId)
  }

  if (typeof age !== undefined) {
    const rangeObj = SARangeArr && SARangeArr.find((item) => {
      return age >= item.ageFrom && age <= item.ageTo
    })
    return rangeObj
  }

}

export function clearRangeMap() {
  SARangeArr = null
}

// 根据保额范围重置保额
export function resetSAValue(value,  minValue, maxValue) {
  if (value < minValue) return minValue
  if (value > maxValue) return maxValue
  return value
}
